import { axiosInstance } from "../clients";

async function listTemplateDescriptions(): Promise<{ templates: { [key: string]: any }[] }> {
  return (await axiosInstance.get(`/v1/storyblok/templates`, { withCredentials: true })).data;
}

export default {
  listTemplateDescriptions,
};
